import { render } from "./FreightManage.vue?vue&type=template&id=d5bd8592"
import script from "./FreightManage.vue?vue&type=script&lang=js"
export * from "./FreightManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__